module.exports = __webpack_public_path__ + "static/img/6.778b18a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/7/zh/6.png
// module id = JAk6
// module chunks = 0